<template>
  <span v-if="remainingDays !== null"
    :class="['badge', remainingDays > 0 ? 'badge--green' : 'badge--red', showBadge ? 'floating': '']">
    {{ $t(remainingDays > 0 ? 'unexpired' : 'expired') }} 
    {{ showRemainingDays(remainingDays) }} ngày
  </span>
</template>
<style scoped>
.badge {
  /* float: right; */
  color: white;
  padding: 2px 4px;
  border-radius: 5px;
  font-size: 10pt;
  border: 1px solid;
}
.floating {
  float: right;
}
.badge--green {
  background: green;
  border-color: green;
}
.badge--red {
  background: #dc3545;
  border-color: #dc3545;
}
</style>
<script lang="ts">
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import * as util from "@/service/util";
  
    @Component({
        name: 'RemainingDaysBadge'
    })
    export default class RemainingDaysBadge extends Vue {
        @Prop({ type: String, required: true }) readonly endTime!: string;
        @Prop({ type: Boolean, required: true }) readonly showBadge!: boolean;

        get remainingDays(){          
           return util.getRemainingDaysOfPackage(this.endTime);
        }

        ///
        showRemainingDays(v) {
          return util.absValue(v);
        }
    }
</script>
